import {
  REFRESH_USER_CUSTOMERS,
  SELECT_CUSTOMER,
  CHANGE_CUSTOMER_STATUS,
  SET_VIEW_CUSTOMER,
  SET_CUSTOMER_DATA,
  SET_CUSTOMER_LIST,
} from './constants'

export const SetCustomerType = (customerType) => (dispatch) => {
  dispatch({
    type: SELECT_CUSTOMER,
    payload: customerType,
  })
}
export const SetCustomerList = (customerList) => (dispatch) => {
  dispatch({
    type: SET_CUSTOMER_LIST,
    payload: customerList,
  })
}
export const SetCustomerData = (customerData) => (dispatch) => {
  dispatch({
    type: SET_CUSTOMER_DATA,
    payload: customerData,
  })
}
export const SetCustomerView = (setCustomerView) => (dispatch) => {
  dispatch({
    type: SET_VIEW_CUSTOMER,
    payload: setCustomerView,
  })
}
export const RefreshUserCustomersList = (refreshCustomerList) => (dispatch) => {
  dispatch({
    type: REFRESH_USER_CUSTOMERS,
    payload: refreshCustomerList,
  })
}
export const ChangeCustomerStatus = (status) => (dispatch) => {
  dispatch({
    type: CHANGE_CUSTOMER_STATUS,
    payload: status,
  })
}
